@if (formGroup()) {
  <ng-container body-content>
    <form [formGroup]="formGroup()">
      <app-international-mobile-phone></app-international-mobile-phone>
    </form>
  </ng-container>
  <div>
    <app-button
      theme="primary-v2"
      tid="confirm-button"
      tabindex="0"
      class="mt-4"
      (click)="submitChanges()"
      [loading]="isUpdatingMfaPreferences()"
      [disabled]="!formGroup()?.valid"
      [uppercaseText]="false"
      [buttonWidth]="'full'"
      icon="arrow-circle-right"
      iconVariant="white"
      iconWeight="fill"
      [fontColor]="'white'"
      buttonText="Register"
    >
    </app-button>
  </div>
}
